import _Replay from "@mui/icons-material/Replay";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Button } from '@mui/material';
const Wrapper = styled.div.withConfig({
  componentId: "sc-13bnpfe-0"
})(["padding:", ";gap:", ";display:flex;flex-direction:column;justify-content:space-between;align-items:center;text-align:center;background-color:", ";"], SIZES['16'], SIZES['16'], COLORS.white);
export default function ModuleError(_ref) {
  let {
    onClick,
    text,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "ModuleError",
    "data-sentry-source-file": "ModuleError.tsx"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "ModuleError.tsx"
  }, text), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "inherit",
    sx: {
      color: COLORS.fupaSecondary,
      backgroundColor: COLORS.lightestGrey
    },
    startIcon: /*#__PURE__*/React.createElement(_Replay, {
      color: "secondary"
    }),
    onClick: onClick,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "ModuleError.tsx"
  }, "Erneut versuchen"));
}